import { Box, Button, createTheme, Grid, Paper, SvgIcon, ThemeProvider, Typography, useMediaQuery, useTheme } from '@mui/material';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as globeIcon } from '../../../assets/images/discover/exploreOptions/globe.svg';
import { ReactComponent as increasing } from '../../../assets/images/discover/exploreOptions/increasing.svg';
import { ReactComponent as link } from '../../../assets/images/discover/exploreOptions/link.svg';
import Toronto from '../../../assets/images/discover/exploreOptions/Toronto.jpg';

const localTheme = (outerTheme: any) => createTheme(
    {
        ...outerTheme,
        breakpoints:{
            values:{
                xs:0,
                sm:701,
                md:1024
            }
        }
    }
)

const StatCard = ({ number, text, icon }) => {
    const iconMap = {
        "link": link,
        "globe": globeIcon,
        "increasing": increasing
    }
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    return (
        <Grid component='li' item xs={12} md={4} sm={4} >
            <Paper
                sx={{
                    height: '100%',
                    maxHeight:"248px",
                    padding: isDesktop ? '40px 28px' : '24px',
                    borderRadius: "14px",
                    backgroundColor: "#FFFFFFE5",
                    display: 'flex',
                    flexDirection: { xs: 'row', md: 'column' },
                    alignItems: isMobile ? 'center' : 'flex-start',
                    gap: '16px',

                }}>
                <Box>
                    <SvgIcon aria-hidden='true' component={iconMap[icon]} viewBox='0 0 48 48' sx={{ fontSize: '48px' }}>

                    </SvgIcon>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                    <Typography component='p' variant='h3' sx={{ fontSize: '28px' }} fontWeight='bold' gutterBottom>
                        {number}
                    </Typography>
                    <Typography component='p' sx={{ fontSize: '16px', fontWeight: 500, wordBreak: 'break-word', overflowWrap: 'anywhere' }} variant='body1'>
                        {text}
                    </Typography>

                </Box>
            </Paper>
        </Grid>
    )
}

const ExploreOptions = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { t, i18n } = useTranslation();
    const data: any = t('ndc-program.home.explore', { returnObjects: true });
    const navigate = useNavigate();
    const handleNavigate = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        navigate(`/${i18n.language}/ndc-program/ndc-capabilities`);
    }
    return (
        <ThemeProvider theme={localTheme(theme)}>
        <Container maxWidth='lg' disableGutters>
            <Box
                component="section"
                aria-labelledby='service-main-h'
                sx={{
                    overflow: 'hidden',
                    padding: { md: '57px 83px', sm: '24px', xs: '24px' },
                    backgroundImage: `url(${Toronto})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    borderRadius: '14px'
                }}>
                <Grid component='ul' sx={{ listStyle: 'none', p: 0, display: 'flex' }} container spacing={3} alignItems='stretch'>
                    <Grid item component='li' xs={12} md={4.5} sx={{ flexGrow: '0' }}>
                        <Paper
                            sx={{
                                padding: "24px 32px",
                                borderRadius: "14px",
                                maxHeight:"248px",
                                height: '100%',
                                backgroundColor: "#FFFFFFE5",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: 'center',
                                gap: '24px',
                            }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <Typography id='service-main-h' sx={{ fontSize: isMobile ? '20px !important' : '28px !important', fontWeight: '700 !important', lineHeight: '28px !important' }} component='h2' variant='h2' fontWeight='bold' gutterBottom>
                                    {data?.mainCard.header}
                                </Typography>
                                <Typography component='p' sx={{ fontSize: isMobile ? '14px !important' : '16px !important', fontWeight: 400 }} variant='body1'>
                                    {data.mainCard.body}
                                </Typography>
                            </Box>
                            <Button component='a' variant='primary' aria-label={data.mainCard.label} onClick={() => handleNavigate()} size={isMobile ? 'sm' : 'md'}>
                                {data.mainCard.button}
                            </Button>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={7.5} sx={{ display: 'flex', flexDirection: { md: 'column' } }}>
                        <Grid container spacing={3} sx={{ flexGrow: '1' }}>
                            {data.statCards.map((element, index) => (<StatCard key={index} number={element.number} text={element.text} icon={element.icon}></StatCard>)
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

        </Container>
        </ThemeProvider>
    )
}

export default ExploreOptions;